import { FieldErrors, FieldError } from 'react-hook-form';

export function getErrorByPath(
  errors: FieldErrors | undefined,
  path: string
): FieldError | undefined {
  if (!errors) return undefined;
  return path.split('.').reduce((acc: any, key: string) => acc?.[key], errors) as FieldError | undefined;
}
